import { AuthenticatedUser, LoginResponse, MenuItem, PermissionType } from '../../../domain/models/session/session';
import { IamSdk } from 'lib-klab-sdks';

interface ErpIdentityLoginResponse {
    accessToken?: string;
    refreshToken?: string;
    tokenType?: string;
    expiresInMs?: number;
    user?: {
        userId?: number;
        employeeId?: number;
        roleId?: number;
        username?: string;
        email?: string;
        role?: string;
    };
}

export function mapSDKLoginToDomain(
    resp: IamSdk.LoginResponse | ErpIdentityLoginResponse,
): LoginResponse {
    if (isErpIdentityLogin(resp)) {
        const user = resp.user;
        return {
            token: {
                access_token: resp.accessToken ?? '',
                refresh_token: resp.refreshToken ?? undefined,
                token_type: resp.tokenType ?? 'Bearer',
                expires_in: resp.expiresInMs ?? 0,
            },
            user: {
                user_id: user?.userId ?? 0,
                username: user?.username ?? '',
                email: user?.email ?? '',
                employee_id: user?.employeeId ?? undefined,
                role: {
                    role_id: user?.roleId ?? roleIdFromName(user?.role),
                    name: user?.role ?? '',
                },
            },
            menu: [],
        };
    }

    return {
        token: {
            access_token: resp.token?.access_token ?? '',
            refresh_token: resp.token?.refresh_token ?? undefined,
            token_type: resp.token?.token_type ?? 'Bearer',
            expires_in: resp.token?.expires_in ?? 0,
        },
        user: mapSDKAuthenticatedUserToDomain(resp.user),
        menu: (resp.menu ?? []).map(mapSDKMenuItemToDomain),
    };
}

function isErpIdentityLogin(
    response: IamSdk.LoginResponse | ErpIdentityLoginResponse,
): response is ErpIdentityLoginResponse {
    return 'accessToken' in response || 'expiresInMs' in response;
}

function roleIdFromName(role: string | undefined): number {
    return {
        ROLE_ADMIN: 1,
        ROLE_GERENTE: 2,
        ROLE_USUARIO: 3,
    }[String(role ?? '').toUpperCase()] ?? 0;
}

export function mapSDKAuthenticatedUserToDomain(
    user: IamSdk.AuthenticatedUser | undefined,
): AuthenticatedUser {
    return {
        user_id: user?.user_id ?? 0,
        username: user?.username ?? '',
        email: user?.email ?? '',
        employee_id: user?.employee_id ?? undefined,
        role: {
            role_id: user?.role?.role_id ?? 0,
            name: user?.role?.name ?? '',
        },
    };
}

export function mapSDKMenuItemToDomain(item: any): MenuItem {
    const childrenRaw = item?.children;

    const children: MenuItem[] = Array.isArray(childrenRaw)
        ? childrenRaw
            .filter((c) => typeof c === 'object' && c !== null)
            .map(mapSDKMenuItemToDomain)
        : [];

    return {
        permission_id: Number(item?.permission_id ?? 0),
        code: String(item?.code ?? ''),
        name: String(item?.name ?? ''),
        permission_type: (item?.permission_type as PermissionType) ?? PermissionType.MenuItem,
        icon: item?.icon ?? undefined,
        order: Number(item?.order ?? 0),
        route: item?.route ?? undefined,
        children,
    };
}
